export class MusicManager {
    constructor() {
        this.audio = null;
        this.isPlaying = false;
        this.toggleBtn = null;
    }

    init() {
        this.toggleBtn = document.getElementById('musicToggle');

        if (!this.toggleBtn) {
            console.warn('Music button not found');
            return;
        }

        // Створюємо Audio об'єкт напряму
        this.audio = new Audio('/audio/background-music.mp3');
        this.audio.loop = true;
        this.audio.volume = 0.3;

        // Add event listeners for debugging
        this.audio.addEventListener('error', (e) => {
            console.error('❌ Помилка завантаження аудіо:', e);
        });

        this.audio.addEventListener('loadeddata', () => {
            console.log('✅ Аудіо файл завантажено успішно');
        });

        this.audio.addEventListener('canplay', () => {
            console.log('🎵 Аудіо готове до відтворення');
        });

        // Toggle button click
        this.toggleBtn.addEventListener('click', () => this.toggle());

        // Auto-play on first user interaction
        document.addEventListener('click', () => this.autoPlay(), { once: true });
    }

    async loadAudioFallback() {
        try {
            // Створюємо новий Audio об'єкт
            const fallbackAudio = new Audio('/audio/background-music.mp3');
            fallbackAudio.loop = true;
            fallbackAudio.volume = 0.3;
            
            await fallbackAudio.load();
            this.audio = fallbackAudio;
            console.log('✅ Аудіо завантажено через fallback');
        } catch (error) {
            console.error('❌ Fallback також не працює:', error);
        }
    }

    async toggle() {
        if (this.isPlaying) {
            this.pause();
        } else {
            await this.play();
        }
    }

    async play() {
        if (!this.audio) return;

        try {
            // Перевіряємо чи завантажено аудіо
            if (this.audio.readyState === 0) {
                console.log('🔄 Завантаження аудіо файлу...');
                await this.audio.load();
            }
            
            await this.audio.play();
            this.isPlaying = true;
            this.toggleBtn.classList.add('playing');
            this.toggleBtn.querySelector('.music-icon').textContent = '🎵';
            console.log('🎵 Музика відтворюється');
        } catch (error) {
            console.error('Помилка відтворення музики:', error);
            console.log('🔍 Перевіряємо шлях до аудіо:', this.audio.src);
        }
    }

    pause() {
        if (!this.audio) return;

        this.audio.pause();
        this.isPlaying = false;
        this.toggleBtn.classList.remove('playing');
        this.toggleBtn.querySelector('.music-icon').textContent = '🔇';
        console.log('🔇 Музика призупинена');
    }

    async autoPlay() {
        // Try to auto-play after first user interaction
        if (!this.isPlaying) {
            await this.play();
        }
    }

    setVolume(volume) {
        if (this.audio) {
            this.audio.volume = Math.max(0, Math.min(1, volume));
        }
    }
}
